import Bowser from 'bowser';
import {Capacitor} from '@capacitor/core';
import packageJson from '../../package.json';

// Recorded on every activity log entry and shown to IT in the Activity Log's
// Diagnostics column. The native apps can lag a long way behind the web build,
// and web users can sit on a cached bundle for weeks, so when diagnosing a
// report the first question is always "which version were they on?" -- this
// answers it without having to ask. Kept in step with package.json, android
// versionName and the iOS CFBundleShortVersionString.
export const APP_VERSION = packageJson.version;
export const APP_PLATFORM = Capacitor.getPlatform();

// Browser/device details for the Diagnostics column. Firestore rejects
// undefined values, so every field falls back to null, and any failure returns
// null rather than blocking the log write it is attached to.
export const getClientInfo = () => {
    try {
        const ua = window.navigator.userAgent;
        const parsed = Bowser.parse(ua);
        const join = (...parts) => parts.filter(Boolean).join(' ') || null;
        const installed = (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
            || window.navigator.standalone === true;
        return {
            browser: join(parsed.browser.name, parsed.browser.version),
            os: join(parsed.os.name, parsed.os.versionName || parsed.os.version),
            device: join(parsed.platform.type, parsed.platform.vendor, parsed.platform.model),
            installed: !!installed,
            user_agent: ua || null,
        };
    } catch (error) {
        console.log("Unable to read client info", error.message);
        return null;
    }
};
